import { useTranslation } from "react-i18next";

const ProductDetailPopUp = ({defaultProductImage, productDetail, sendCommandToCloseModal}) => {
    const { t } = useTranslation();
    const handleModalClose = (e) => {
        e.preventDefault();
        sendCommandToCloseModal();
    };

    return (
        <div className="fixed z-50 overflow-y-auto top-0 w-full left-0">
            <div className="flex items-center justify-center min-height-100vh px-4 py-20 text-center sm:block sm:p-0">
                <div className="fixed inset-0 transition-opacity">
                    <div className="absolute inset-0 bg-gray-900 opacity-75" />
                </div>
                <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>
                <div className="inline-block align-center bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-sm sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                    <div className="bg-white py-4 px-4 sm:px-6 space-y-1 sm:space-y-2 min-h-auto max-h-[33rem] overflow-y-auto no-scrollbar">
                        <div className="flex justify-between">
                            <div className="font-semibold capitalize">{ t('product code')}: {productDetail.item_code}</div>
                            <div className="cursor-pointer" onClick={(e) => handleModalClose(e)}>
                                <img src="../../../../assets/icons/modal-cross.svg" alt="cross" />
                            </div>
                        </div>
                        <div className="flex flex-col justify-center items-center py-1">
                            <img className="w-56 h-56 border border-black-100 rounded-2xl" src={productDetail.image ? productDetail.image : defaultProductImage} alt="product-img" />
                        </div>
                        <div>
                            <h1 className="font-bold sm:text-md">{productDetail.b2bline1}</h1>
                            <div className="text-light-400 capitalize text-xs">{productDetail.b2bline2}</div>
                            <div className="text-light-400 capitalize text-xs">{productDetail.b2bline3}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductDetailPopUp;